import { render, staticRenderFns } from "./PFWizardFront.vue?vue&type=template&id=289b29e6"
import script from "./PFWizardFront.vue?vue&type=script&lang=js"
export * from "./PFWizardFront.vue?vue&type=script&lang=js"
import style0 from "./PFWizardFront.vue?vue&type=style&index=0&id=289b29e6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports